import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IVideoWatchReport } from '../models/responseModels'

export class GetVideoWatchReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video/watch-report',
      requesterInfo,
    })
  }

  public async getWatchReport(): Promise<IVideoWatchReport[]> {
    return await this.getAsync<IVideoWatchReport[]>()
  }
}
